import {StramashGig13March25List} from "./media/pictures/gigs/StramashGig13March25/StramashGig13March25"
import {Homebar30Nov25List} from "./media/pictures/gigs/Homebar30Nov25/Homebar30Nov25"
import {KrakatoaMay23List} from "./media/pictures/gigs/KrakatoaMay23/KrakatoaMay23"
import {BannermasApr19List} from "./media/pictures/gigs/BannermasApr19/BannermasApr19"
import shelterCover from './media/pictures/cits-shelter-cover.jpg';
import MuseArtwork from './media/songsArtwork/MuseArtwork.jpg'
import HomebarGigSquare from "./media/pictures/gigs/Homebar-Gig-Square.jpg"
import BannermansVertical from "./media/ogImages/BannermansVertical.jpeg"
import WhistlebinkiesVertical from "./media/ogImages/WhistlebinkiesVertical.png"
import WhistlebinkiesOg from "./media/ogImages/WhistlebinkiesOg.jpg"
import BannermansOGv from "./media/ogImages/BannermansOGv.jpg"
import ShareItWithUsOgImage from "./media/ogImages/ShareItWithUsOgImage.jpg"


import {socialMediaIcons} from "./displayConfig";

export const homepage = 'https://campingintheskies.web.app'
export const citsWebsite = 'https://campingintheskies.com/'
export const campingInTheSkies = 'Camping In The Skies'
export const shareOnWhatsAppThe = 'whatsapp://send?text='
export const citsBandcamp = 'https://campingintheskies.bandcamp.com/'
export const youTubeMusicCits = 'https://music.youtube.com/watch?v=lhSez-e0NuY'
export const amazonMusicCits = 'https://music.amazon.com/albums/B0BN8QSGBC'
export const appleMusicCits = 'https://music.apple.com/gm/artist/camping-in-the-skies/1642724146'
export const spotifyCits = 'https://open.spotify.com/album/0EcSXSkPNQUeHho9u0fJA9'
export const followOnFacebookCits = 'https://www.facebook.com/campingintheskies'
export const followOnInstagramCits = 'https://www.instagram.com/campingintheskies/'
export const followOnYouTubeCits = 'https://www.youtube.com/channel/UC4X7q03_DAWZL3X0mzYKOYQ?sub_confirmation=1'
export const followOnTikTokCits = 'https://www.tiktok.com/@campingintheskies'
export const followOnTwitterCits = 'https://campingintheskies.com/wp-content/uploads/2023/04/share-listen-follow-Twitter.png'
export const shareFacebookCits = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcampingintheskies.com%2F&src=sdkpreparse'
export const shareTwitterCits = 'https://campingintheskies.com/wp-content/uploads/2023/04/share-listen-follow-Twitter.png'
export const citsEmailAddress = 'campingintheskies@gmail.com'
export const citsMailtoEmailAddress = `mailto:${citsEmailAddress}`
export const citsWhatsAppChannel = 'https://chat.whatsapp.com/FG9Ut1hDeiWHSPvmNEny63'
export const citsSwissTransferFileTransfer = 'https://www.swisstransfer.com/en'
export const youTubePlaylistCITS = 'https://www.youtube.com/watch?v=FTlNNAjyDr0&list=PLWVpjoVPTvc6C5hJbvdIehMzc8tgaXSUy&index=1'
export const youTubeEmbedPlaylistCITS = 'https://www.youtube.com/embed/videoseries?si=x5p2dlLLhej_NejZ&amp;list=PLWVpjoVPTvc6C5hJbvdIehMzc8tgaXSUy'
export const youTubeChannel = 'https://www.youtube.com/@campingintheskies'
export const paypalDonateLink = 'https://www.paypal.com/donate/?hosted_button_id=SBL9E2MQN3RVE'

export const mermbersAndPartners = {
 scottFullName: 'Scott Davie',
 domFullName: 'Dom Owtram',
 omarFullName: 'Omar Daniel Docherty',
 mattSelvansFullName: 'Matt Selvans',
 rodaidhFullName: 'Rodaidh Mackay',
 bijayFullName: 'Bijay Shrestha',
 monniFullName: 'Monni Kamenov',
 liamFullName: 'Liam Beedie',
 mattJollyFullName: 'Matt Jolly',
 williamOr: 'William Orr',
 jamesKing: 'James King',
 roryEmson: 'Rory Emson'
}

export const getFullUrl = (importedPath) => {
    // If it's already a full URL (http/https), return as-is
    if (typeof importedPath === 'string' && importedPath.startsWith('http')) {
        return importedPath;
    }

    // For Webpack-processed images (they're objects in development)
    if (typeof importedPath !== 'string') {
        return process.env.NODE_ENV === 'production'
            ? `https://campingintheskies.com${importedPath.default || importedPath}`
            : importedPath.default || importedPath;
    }

    // For string paths in production
    if (process.env.NODE_ENV === 'production') {
        return `https://campingintheskies.com${importedPath}`;
    }

    return importedPath;
};

export const PagesList = {
      discography: {
          route: '/discography',
          pageName: `Discography ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Delve into the Discography of Camping In The Skies, a testament to their unwavering commitment to their craft. Each track is born out of sleepless nights and long shifts, a dance with uncertainty and creativity. From this process, emerges music that’s polished, well-thought-out, and filled with soul. Their enticing lyrics resonate in every tune, reflecting their dedication. Experience the fruits of their labor at ‘Camping in the Skies’',
          keywords: 'Discography, Alt Rock Band, Self-Produced Music, Empowering Lyrics, Encouraging Music, Sleepless Nights, Long Shifts, Masterpieces, Musical Excellence, Polished Tracks, Soulful Music, Edinburgh and Tenerife, Online Collaboration, In-Person Collaboration, Original Music Videos, Original Photos, Camping in the Skies, Passionate Creations, Inspirational Tunes, Creative Journey, Independent Label'
      },
      homepage: {
          route: '/',
          pageName: `Homepage ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Immerse yourself in Camping in the Skies, an alt rock band based between Edinburgh and Tenerife. The band\'s work transcends geographical boundaries as they collaborate both online and in-person. Discover their unique blend of creativity and learn all about the band at ‘Camping in the Skies’ official website.',
          keywords: 'Immerse yourself in Camping in the Skies, an alt rock band based between Edinburgh and Tenerife. The band\'s work transcends geographical boundaries as they collaborate both online and in-person. Discover their unique blend of creativity and learn all about the band at ‘Camping in the Skies’ official website.'
      },
      homebarGig: {
          route: '/hbg',
          pageName: `Homebar Gig Thursday 23rd of may ${campingInTheSkies}`,
          ogImage: getFullUrl(HomebarGigSquare),
          description: `Come and hear the future and past singles of ${campingInTheSkies} at Homebar Edinburgh`,
          keywords: `Gig, Scotland, Singles, alt-rock, Homebar, 69 home street, ${campingInTheSkies}`
      },
      aboutUs: {
          route: '/about-us',
          pageName: `About ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Camping In The Skies: an alt rock band based between Scotland and Tenerife. Learn more about their unique creative partnership, and their musical journey.',
          keywords: 'About Us, Camping In The Skies, Band History, Band Members, Musical Journey, Band Inspiration, Musical Style, Album Releases, Concert Tours, Fan Base, Music Creation Process, Songwriting Process, Band Achievements, Future Plans, Band Interviews, Press Coverage, Social Impact, Community Involvement, Collaborations, Music Awards.'
      },
      newsletter: {
          route: '/newsletter',
          pageName: `Newsletter ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Camping In The Skies: an alt rock band. Keep updated on their latest news, releases, and events. Subscribe to their newsletter and get exclusive access to their behind-the-scenes stories, sneak peeks, and special offers.',
          keywords: 'Newsletter, Camping In The Skies Updates, Band News, Latest Releases, Upcoming Events, Behind-The-Scenes Stories, Exclusive Content, Fan Engagement, Music Industry Insights, Band Interviews, Personal Anecdotes, Tour Announcements, Album Launches, Song Teasers, Fan Club News, Special Offers, Merchandise Updates, Meet and Greet Opportunities, Fan Art Features, Community Highlights,'
      },
      photos: {
          route: '/photos',
          pageName: `Photo Gallery ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Step into the vibrant world of Camping In The Skies through their Photo Gallery. This collection captures the band’s best moments, chronicling their journey from inception to the present day. From behind-the-scenes shots to concert highlights, experience the essence of Camping In The Skies.',
          keywords: 'Photo Gallery, Camping In The Skies, Best Moments, Band Journey, Behind-The-Scenes, Concert Highlights, Musical Universe, Living The Moment, Captured Memories, Band Photography, Musician’s Life, On-Stage Moments, Off-Stage Moments, Band’s Evolution, Musical Milestones, Creative Process, Passionate Performances, Inspirational Images, Empowering Visuals, Encouraging Journey,'
      },
      videos: {
          route: '/videos',
          pageName: `Video Gallery ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Camping In The Skies: an alt rock band. Showcasing their musical and visual talents in their video gallery. Explore their music videos, their captivating live performances, and their fun and creative behind-the-scenes videos.',
          keywords: 'Video Gallery, Camping In The Skies Videos, Band Performances, Music Videos, Behind-The-Scenes Footage, Concert Clips, Exclusive Previews, Song Teasers, Tour Diaries, Fan Reactions, Interview Footage, Studio Sessions, Album Launches, Meet and Greet Clips, Rehearsal Videos, Creative Process, Live Shows, Collaborations, Acoustic Sets'
      },
      events: {
          route: '/events',
          pageName: `Events ${campingInTheSkies}`,
          ogImage: getFullUrl(shelterCover),
          description: 'Camping In The Skies: an alt rock band. Showcasing their musical and visual talents in their video gallery. Explore their music videos, their captivating live performances, and their fun and creative behind-the-scenes videos.',
          keywords: 'Video Gallery, Camping In The Skies Videos, Band Performances, Music Videos, Behind-The-Scenes Footage, Concert Clips, Exclusive Previews, Song Teasers, Tour Diaries, Fan Reactions, Interview Footage, Studio Sessions, Album Launches, Meet and Greet Clips, Rehearsal Videos, Creative Process, Live Shows, Collaborations, Acoustic Sets'
      },
    share: {
        route: '/share',
        pageName: `Share the magic | ${campingInTheSkies}`,
        ogImage: getFullUrl(ShareItWithUsOgImage),
        description: 'Share your photos and videos from Camping In The Skies. Upload your favorite memories, tag us on socials, and you might be featured in our future content!',
        keywords: 'Camping In The Skies fan uploads, share concert photos, live music fan videos, upload memories, fan gallery, camping in the skies community, submit content, fan spotlight, live event photos'
        },
    };

export const songLinksList = {
    muse: {
        route: '/discography/muse',
        pageName: `Muse ${campingInTheSkies}`,
        ogImage: getFullUrl(MuseArtwork),
        description: 'New single released december 1st 2023. Get inspired!',
        keywords: 'Single, Discography, Alt Rock Band, Self-Produced Music, Empowering Lyrics, Encouraging Music, Sleepless Nights, Long Shifts, Masterpieces, Musical Excellence, Polished Tracks, Soulful Music, Edinburgh and Tenerife, Online Collaboration, In-Person Collaboration, Original Music Videos, Original Photos, Camping in the Skies, Passionate Creations, Inspirational Tunes, Creative Journey, Independent Label'
    },
}
export const PhotoAlbumList = [
    {
        albumName: 'Live at Stramash 13th of March 2025',
        albumCover: StramashGig13March25List[0],
        photos: StramashGig13March25List,
        url: `${PagesList.photos.route}/live-at-stramash-mar-2025`,
        description:
            'Live at Stramash. Edinburgh March 2025 \n' +
            ` ${mermbersAndPartners.rodaidhFullName} - Guitar\n` +
            ` ${mermbersAndPartners.roryEmson} - Bass\n` +
            ` ${mermbersAndPartners.jamesKing} - Drums\n` +
            ` ${mermbersAndPartners.williamOr} - Guitar/Synth.\n` +
            ` ${mermbersAndPartners.mattSelvansFullName} - Vocals\n` +
            ` Photography - Jack Joseph`,
        keywords: 'Camping In The Skies, March 2025, Stramash Venue, Edinburgh, Live Music, Concert Photography, Music Venue, Alt Rock Band, UK Music Scene, Indie Music, Live Performance, Band Photography, Edinburgh Nightlife, Music Event, Scotland Music'
    },
    {
        albumName: 'Live at Homebar 30th of November 2024',
        albumCover: Homebar30Nov25List[0],
        photos: Homebar30Nov25List,
        url: `${PagesList.photos.route}/live-at-homebar-nov-2024`,
        description:
            'Live at Homebar. Edinburgh Novembner 2024 \n' +
            ` ${mermbersAndPartners.mattSelvansFullName} - Vocals\n` +
            ` ${mermbersAndPartners.rodaidhFullName} - Guitar\n` +
            ` ${mermbersAndPartners.roryEmson} - Bass\n` +
            ` ${mermbersAndPartners.jamesKing} - Drums\n` +
            ` ${mermbersAndPartners.williamOr} - Guitar/Synth.\n` +
            ` Photography - Marek Stefanski & Bren`,
        keywords: 'Camping In The Skies, November 2024, Homebar Venue, Edinburgh, Live Music, Concert Photography, Music Venue, Alt Rock Band, UK Music Scene, Indie Music, Live Performance, Band Photography, Edinburgh Nightlife, Music Event, Scotland Music'
    },
    {
        albumName: 'Live at Krakatoa May 2023',
        albumCover: KrakatoaMay23List[0],
        photos: KrakatoaMay23List,
        url: `${PagesList.photos.route}/live-at-krakatoa-may-2023`,
        description:
            'Live at Krakatoa supporting the Funky Red Pandas. Aberdeen May 2023 \n' +
            ` ${mermbersAndPartners.mattSelvansFullName} - Vocals\n` +
            ` ${mermbersAndPartners.rodaidhFullName} - Guitar\n` +
            ` ${mermbersAndPartners.bijayFullName} - Bass\n` +
            ` ${mermbersAndPartners.monniFullName} - Drums\n` +
            ` ${mermbersAndPartners.liamFullName} - Drums/Percussion.\n` +
            ` Photography - ${mermbersAndPartners.mattJollyFullName}`,
        keywords: 'Camping In The Skies, Second Gig, May 2023, Krakatoa Venue, Aberdeen, Live Music, Concert Photography, Music Venue, Alt Rock Band, UK Music Scene, Indie Music, Live Performance, Band Photography, Aberdeen Nightlife, Music Event, Matt Jolly Photography, The Funky Red Pandas, Full Fat, JwJ, Scotland Music'
    },
    {
        albumName: 'Bannerman\'s Bar. First gig',
        albumCover: BannermasApr19List[0],
        photos: BannermasApr19List,
        url: `${PagesList.photos.route}/live-at-bannermans-bar-2019`,
        description:
            'Camping in the skies\' first live performance. Edinburgh April 2019.\n' +
            ` ${mermbersAndPartners.mattSelvansFullName} - Vocals\n` +
            ` ${mermbersAndPartners.rodaidhFullName} - Guitar\n` +
            ` ${mermbersAndPartners.scottFullName} - Bass\n` +
            ` ${mermbersAndPartners.domFullName} - Drums\n` +
            `Photography - ${mermbersAndPartners.omarFullName}`,
        keywords: 'Rock Concert, Live Performance, Band Photography, Music Scene, Edinburgh Nightlife, UK Music, Indie Music, New Band, Music Event, Pub Gig, Camping In The Skies, Alt Rock Band, First Gig, Bannerman’s Bar, Edinburgh, UK, April 2019, Live Music, Concert Photography, Music Venue Pub'
    },
    { socialMedia: followOnInstagramCits, icon: socialMediaIcons.instagram},
]
export const AllAlbumPhotos = PhotoAlbumList.flatMap(album =>
    album.photos ? album.photos : []
);

export const EventsList= [
    {
        //IMAGE PROMPT LINK https://chatgpt.com/c/6a561ac6-5638-83ed-86d2-4c0e10f4c47e and fetch more info at campingintheskies.com
        eventName: 'After the Fall - Whistlebinkies Wednesday 2nd of September',
        dateAndTime: '23:59pm 2nd of September',
        eventCountDown: 'September 2, 2026 23:59:00',
        goToVenueFromOwnLocation: 'https://www.google.com/maps/dir/?api=1&destination=Whistlebinkies,+4-6+South+Bridge,+Edinburgh+EH1+1LL,+United+Kingdom',
        facebookEventPage: null,
        youTubePlaylist: null,
        buttonsAndTimeBackgroundColor: '#26201d',
        buttonsAndTimeFontColor: '#ffffff',
        countDownLabelsColor: '#26201d',
        onHoverColor: '#005cbe',
        eventPageBackgroundColor: '#005cbe',
        windowsBackground: '#beaca1',
        fontColor: '#26201d',
        //eventCover MUST BE A4 portrait
        eventCover: WhistlebinkiesVertical,
        photos: '',
        ticketsLink: null,
        url: `${PagesList.events.route}/Whistlebinkies`,
        description: 'Camping In The Skies is hitting Whistlebinkies on Wednesday 2nd September at 11:59PM.\n' +
            'Camping In The Skiesis coming for the vaults — alt-rock, psychedelic, progressive, and sharp rap beats colliding under South Bridge.\n' +
            '\n' +
            'Expect heavy riffs. Expect chaos. Expect moments that hit harder than the spirits lingering in the Edinburgh vaults below.\n' +
            'Free entry every night — but the noise, sweat, and atmosphere? Absolutely priceless.\n' +
            '\n' +
            'This isn\'t just a Wednesday night.\n' +
            'It\'s the kind of show people will claim they were at… even when they weren\'t.\n' +
            'See you in the vaults.\n',
        participatingArtists : [
            {name: 'Camping In The Skies'},
        ],
        route: `${PagesList.events.route}/whistlebinkies`,
        pageName: 'Camping in the Skies Live · Whistlebinkies · Wednesday 2nd September',
        //OG Image must be either 1:1(630x630) or 5:7(857x1200) or 1200x630  300kb max
        ogImage: getFullUrl(WhistlebinkiesOg),
        keywords: 'Camping In The Skies, July 2026, Whistlebinkies, Edinburgh, Live Music, Concert Photography, Music Venue, Alt Rock Band, UK Music Scene, Indie Music, Live Performance, Band Photography, Edinburgh Nightlife, Music Event, Scotland Music'
    },
    {
        //IMAGE PROMPT LINK https://chatgpt.com/c/6a561ac6-5638-83ed-86d2-4c0e10f4c47e
        eventName: 'Bannerman\'s Monday 27th of July',
        dateAndTime: '7pm 27th of July',
        eventCountDown: 'July 27, 2026 20:00:00',
        goToVenueFromOwnLocation: 'https://www.google.com/maps/dir/?api=1&destination=212+Cowgate+EH1+1NQ+United+Kingdom',
        facebookEventPage: null,
        youTubePlaylist: null,
        buttonsAndTimeBackgroundColor: '#26201d',
        buttonsAndTimeFontColor: '#ffffff',
        countDownLabelsColor: '#26201d',
        onHoverColor: '#aa0000',
        eventPageBackgroundColor: '#aa0000',
        windowsBackground: '#beaca1',
        fontColor: '#26201d',
        //eventCover MUST BE A4 portrait
        eventCover: BannermansVertical,
        photos: '',
        ticketsLink: "https://buytickets.at/campingintheskies/2309371",
        url: `${PagesList.events.route}/bannermans`,
        description: 'Something strange is about to hit Bannerman’s on Monday 27th July at 8PM.\n' +
            'Camping In The Skies, Responsible Adult, and The Apaches are gearing up to flip the venue inside out — loud guitars, questionable decisions, and absolutely no regrets.\n' +
            '\n' +
            'Expect drama. Expect chaos. Expect moments that will make you rethink your life choices in the best way.\n' +
            '100% gluten free — but the noise, sweat, and atmosphere will hit heavy.\n' +
            '\n' +
            'Tickets are flying — grab yours ASAP before they’re gone:\n' +
            '\n' +
            'This isn’t just another night out.\n' +
            'It’s the kind of event people claim they were at… even when they weren’t.\n' +
            'See you under the low lights.\n',
        participatingArtists : [
            {name: 'Camping In The Skies'},
            {name: 'Responsible Adult', link: 'https://www.instagram.com/responsibleadultband/'},
            {name: 'The Apaches', link: 'https://www.instagram.com/the_apaches_/'},
        ],
        route: `${PagesList.events.route}/bannermans`,
        pageName: 'Camping in the Skies Live · Bannerman\'s · Monday 27th July',
        //OG Image must be either 1:1(630x630) or 5:7(857x1200) or 1200x630  300kb max
        ogImage: getFullUrl(BannermansOGv),
        keywords: 'Camping In The Skies, July 2026, Bannerman\'s, Edinburgh, Live Music, Concert Photography, Music Venue, Alt Rock Band, UK Music Scene, Indie Music, Live Performance, Band Photography, Edinburgh Nightlife, Music Event, Scotland Music'
    },
]

//Camping In The Skies © {new Date().getFullYear()} - All rights reserved